import React, { useEffect, useState, useRef, createElement } from 'react';
import { YtJuevesCountdownTimer } from './YtJuevesCountdownTimer';
import { YtJuevesRegistrationModal } from './YtJuevesRegistrationModal';
import { CalendarIcon, ClockIcon, GiftIcon } from 'lucide-react';
export function YtJuevesHero({
  isPaused,
  setShowThankYou
}: {
  isPaused: boolean;
  setShowThankYou: (show: boolean) => void;
}) {
  const playerRef = useRef<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSuccess = () => {
    setIsModalOpen(false);
    setShowThankYou(true);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
    if (playerRef.current) {
      playerRef.current.pause();
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    // Load Wistia player scripts
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/1r1ngrgitd.js';
    script2.async = true;
    script2.type = 'module';
    document.head.appendChild(script2);
    // Wait for Wistia to load and get player reference
    const checkWistia = setInterval(() => {
      if (window.Wistia) {
        const player = window.Wistia.api('1r1ngrgitd');
        if (player) {
          playerRef.current = player;
          clearInterval(checkWistia);
        }
      }
    }, 100);
    return () => {
      clearInterval(checkWistia);
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  useEffect(() => {
    if (playerRef.current && isPaused) {
      playerRef.current.pause();
    }
  }, [isPaused]);
  return <section className="text-center" data-id="element-811">
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='1r1ngrgitd']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1r1ngrgitd/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:56.25%; 
          }
          wistia-player::part(time) {
            display: none !important;
          }
          wistia-player::part(playbar-time) {
            display: none !important;
          }
          .wistia_embed .w-chrome .w-controlbar-above .w-controlbar .w-controlbar-left .w-time {
            display: none !important;
          }
          .video-container {
            position: relative;
            z-index: 10;
            min-height: 200px;
          }
          .geometric-grid {
            position: absolute;
            width: 100%;
            height: 200px;
            overflow: hidden;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            z-index: 0;
            pointer-events: none;
          }
          .geometric-grid::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 200%;
            height: 300px;
            background-image: 
              linear-gradient(90deg, rgba(239, 68, 68, 0.3) 2px, transparent 2px),
              linear-gradient(0deg, rgba(239, 68, 68, 0.3) 2px, transparent 2px);
            background-size: 40px 40px;
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            transform-origin: center center;
            mask-image: radial-gradient(ellipse at center, black 35%, transparent 85%);
            -webkit-mask-image: radial-gradient(ellipse at center, black 35%, transparent 85%);
          }
          .geometric-grid::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px;
            height: 3px;
            background: rgba(239, 68, 68, 0.9);
            border-radius: 50%;
            box-shadow: 
              0 0 6px rgba(239, 68, 68, 0.8),
              0 0 10px rgba(239, 68, 68, 0.6),
              80px 40px 0 rgba(239, 68, 68, 0.9),
              80px 40px 6px rgba(239, 68, 68, 0.8),
              -80px -40px 0 rgba(239, 68, 68, 0.9),
              -80px -40px 6px rgba(239, 68, 68, 0.8);
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            animation: laserBeamHorizontal 3s linear infinite;
          }
          .geometric-grid .vertical-beams {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px;
            height: 3px;
            background: rgba(239, 68, 68, 0.9);
            border-radius: 50%;
            box-shadow: 
              0 0 6px rgba(239, 68, 68, 0.8),
              0 0 10px rgba(239, 68, 68, 0.6),
              40px 80px 0 rgba(239, 68, 68, 0.9),
              40px 80px 6px rgba(239, 68, 68, 0.8),
              -40px -80px 0 rgba(239, 68, 68, 0.9),
              -40px -80px 6px rgba(239, 68, 68, 0.8);
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            animation: laserBeamVertical 3.5s linear infinite;
          }
          @keyframes laserBeamHorizontal {
            0%, 100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(-200px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(200px);
              opacity: 0;
            }
          }
          @keyframes laserBeamVertical {
            0%, 100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(150px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(-150px);
              opacity: 0;
            }
          }
          @media (min-width: 768px) {
            .geometric-grid {
              height: 400px;
            }
            .geometric-grid::before {
              background-size: 60px 60px;
              height: 500px;
            }
            .geometric-grid::after {
              width: 4px;
              height: 4px;
              box-shadow: 
                0 0 8px rgba(239, 68, 68, 0.8),
                0 0 12px rgba(239, 68, 68, 0.6),
                120px 60px 0 rgba(239, 68, 68, 0.9),
                120px 60px 8px rgba(239, 68, 68, 0.8),
                240px 120px 0 rgba(239, 68, 68, 0.9),
                240px 120px 8px rgba(239, 68, 68, 0.8),
                -120px -60px 0 rgba(239, 68, 68, 0.9),
                -120px -60px 8px rgba(239, 68, 68, 0.8),
                -240px -120px 0 rgba(239, 68, 68, 0.9),
                -240px -120px 8px rgba(239, 68, 68, 0.8);
              animation: laserBeamHorizontal 3s linear infinite;
            }
            .geometric-grid .vertical-beams {
              width: 4px;
              height: 4px;
              box-shadow: 
                0 0 8px rgba(239, 68, 68, 0.8),
                0 0 12px rgba(239, 68, 68, 0.6),
                60px 120px 0 rgba(239, 68, 68, 0.9),
                60px 120px 8px rgba(239, 68, 68, 0.8),
                -60px 180px 0 rgba(239, 68, 68, 0.9),
                -60px 180px 8px rgba(239, 68, 68, 0.8),
                120px -60px 0 rgba(239, 68, 68, 0.9),
                120px -60px 8px rgba(239, 68, 68, 0.8);
            }
            .video-container {
              min-height: 400px;
            }
            @keyframes laserBeamHorizontal {
              0%, 100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(-300px);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(300px);
                opacity: 0;
              }
            }
            @keyframes laserBeamVertical {
              0%, 100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(250px);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(-250px);
                opacity: 0;
              }
            }
          }
        `
    }} data-id="element-812" />

      {/* Event Date/Time Info Bar - Integrated Design */}
      <div className="bg-gray-800 bg-opacity-30 backdrop-blur-sm border-l-4 border-red-500 py-4 px-6 mb-6 md:mb-8" data-id="element-813">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8" data-id="element-814">
          <div className="flex items-center gap-2" data-id="element-815">
            <CalendarIcon className="h-5 w-5 text-red-400" data-id="element-816" />
            <span className="text-white font-semibold text-sm sm:text-base" data-id="element-817">
              Jueves, 8 de Enero
            </span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-gray-600" data-id="element-818"></div>
          <div className="flex items-center gap-2" data-id="element-819">
            <ClockIcon className="h-5 w-5 text-red-400" data-id="element-820" />
            <span className="text-white font-semibold text-sm sm:text-base" data-id="element-821">
              7:00 PM (Hora del Este)
            </span>
          </div>
        </div>
      </div>

      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-red-500 leading-tight px-4" style={{
      fontFamily: 'Poppins, sans-serif'
    }} data-id="element-822">
        Masterclass Gratuita: Cómo Diseñar Productos Digitales con IA
      </h1>

      <p className="text-base md:text-lg text-gray-300 px-4 mb-4" data-id="element-823">
        (Marco educativo para entender el proceso desde cero)
      </p>

      <p className="text-sm md:text-base text-gray-400 px-4 mb-4" data-id="element-824">
        Una sesión educativa de 90 minutos para comprender cómo funciona este
        modelo de negocio digital.
      </p>

      <div className="flex justify-center relative mb-6 md:mb-8" data-id="element-825">
        <div className="geometric-grid" data-id="element-826">
          <div className="vertical-beams" data-id="element-827"></div>
        </div>
        <div className="w-full max-w-3xl px-4 video-container" data-id="element-828">
          <div className="relative rounded-lg md:rounded-2xl p-0.5 md:p-1 bg-gradient-to-br from-gray-800/50 to-gray-900/50 shadow-2xl aspect-video" data-id="element-829">
            <wistia-player media-id="1r1ngrgitd" aspect="1.7777777777777777" data-id="element-830"></wistia-player>
          </div>
        </div>
      </div>

      {/* Special Gift Info Bar - Integrated Design */}
      <div className="bg-gray-800 bg-opacity-30 backdrop-blur-sm border-l-4 border-yellow-500 py-4 px-6 mb-6 max-w-3xl mx-auto" data-id="element-831">
        <div className="flex items-start sm:items-center gap-3" data-id="element-832">
          <GiftIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-833" />
          <div className="text-left" data-id="element-834">
            <p className="text-yellow-400 font-bold text-xs uppercase tracking-wide mb-1" data-id="element-835">
              Material Educativo Exclusivo para Asistentes en Vivo
            </p>
            <p className="text-white text-sm sm:text-base leading-relaxed" data-id="element-836">
              Incluye un recurso complementario y una guía de referencia que
              resume los conceptos explicados durante la masterclass, con el
              objetivo de facilitar su comprensión y estudio posterior.
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-center mb-6 md:mb-8" data-id="element-837">
        <div className="w-full max-w-3xl px-4" data-id="element-838">
          <button onClick={handleOpenModal} className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-lg sm:text-xl md:text-2xl font-bold py-4 md:py-5 px-8 md:px-12 shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 flex items-center justify-center touch-manipulation" data-id="element-839">
            RESERVA TU LUGAR GRATIS
            <span className="ml-2 md:ml-3 text-xl md:text-2xl" data-id="element-840">→</span>
          </button>
        </div>
      </div>

      <div className="flex justify-center mb-6 md:mb-8" data-id="element-841">
        <div className="w-full max-w-3xl px-4" data-id="element-842">
          <img src="https://cdn.magicpatterns.com/uploads/1cVYLqSP4PbWDgrRQPU8aV/tmp5djoo1mh.webp" alt="Guía de Referencia" className="w-full h-auto" data-id="element-843" />
        </div>
      </div>

      <div className="mb-6 md:mb-8" data-id="element-844">
        <YtJuevesCountdownTimer data-id="element-845" />
      </div>

      <YtJuevesRegistrationModal isOpen={isModalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} data-id="element-846" />
    </section>;
}
declare global {
  interface Window {
    Wistia: any;
  }
}